import React, { ComponentProps } from 'react';
import { AnnouncementList } from './partials/AnnouncementList/AnnouncementList';
import { asBlock } from '../../_lib/BlockFetcher';
import { BlockType } from '../../types/api/ElementType';
import { PaginationItemWithPageLink } from '../../_lib/components/Pagination';
import { AnnouncementProps } from './Announcement.types';

type AnnouncementsContext = {
  pageItems?: PaginationItemWithPageLink[];
  announcements: AnnouncementProps[];
};

function AnnouncementsInbox({ announcements, pageItems }: AnnouncementsContext) {
  return <AnnouncementList announcements={announcements} pageItems={pageItems} />;
}

export const AnnouncementsInboxBlock = asBlock(AnnouncementsInbox, BlockType.allannouncementsinbox);
export type AnnouncementsInboxBlock = ComponentProps<typeof AnnouncementsInboxBlock>;
